var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((this.episodes),function(content,index){return _c('div',{key:index},[_c('div',{staticClass:"card",on:{"click":function($event){_vm.$router.push({ path: '/episode/' + content.episode_id });
        _vm.$store.commit('updateEpisodeId', content.episode_id);
        _vm.$store.commit('updateEpisodeIndex', content.episode_index);
        _vm.$store.commit('updateEpisodeLength', content.episode_length);}}},[_c('div',{staticClass:"container",class:{
          'eyal-weizman-filter': index == 0,
          'benedicte-savoy-filter': index == 1,
          'priya-basil-filter': index == 2,
          'fred-ritchin-filter': index == 3,
          'rabih-mroue-filter': index == 4,
          'christina-varvia-filter': index == 5,
          'claudia-jimenez-filter': index == 6,
          'mark-sealy-filter': index == 7,
          'ixmucane-aguilar-filter': index == 8,
        }},[_c('img',{attrs:{"src":require('../assets/speaker/' + content.speaker + '.jpg'),"alt":""}}),_c('div',{staticClass:"bottom-left"},[_vm._v(_vm._s(content.title))])]),_c('div',{staticClass:"subtitle"},[_vm._v(" "+_vm._s(content.description)+" ")])])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }